export default ['authenticate'];



// WEBPACK FOOTER //
// ./src/modules/landing-alias/index.js